export default {
  code: 'ja',
  messages: {
    required: '必須項目です、入力してください。',
  },
};
